import { Box, Typography } from "@mui/material";
import React from "react";
import AvatarIcon from "../../../assets/SVG/avatarIcon";
import CalendarIcon from "../../../assets/SVG/calendarIcon";
import CallIcon from "../../../assets/SVG/callIcon";
import DescriptionIcon from "../../../assets/SVG/descriptionIcon";
import PhoneIcon from "../../../assets/SVG/phoneIcon";
import PhoneIcon2 from "../../../assets/SVG/phoneIcon2";
import ProfileIcon from "../../../assets/SVG/profileIcon";
import UniversityCapIcon from "../../../assets/SVG/universityCapIcon";
import UserIcon from "../../../assets/SVG/userIcon";

export function LabelInformation({
  children,
  label,
  value,
  color,
  width,
  ...props
}) {
  return (
    <Box
      width={width || "100%"}
      display="flex"
      mt="15px"
      alignItems={"center"}
      {...props}
    >
      <Box
        width="35px"
        height="35px"
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        borderRadius={"50%"}
        border={`solid 1px ${color || "#9A9A9A"}`}
      >
        {children}
      </Box>
      {label && (
        <Typography
          sx={{ minWidth: "max-content" }}
          mr="10px"
          color={color || "#9A9A9A"}
        >{`${label} :`}</Typography>
      )}
      <Typography
        sx={{ minWidth: "max-content" }}
        mr="5px"
        color={color || "#9A9A9A"}
      >
        {value}
      </Typography>
    </Box>
  );
}
export default function GeneralInformation({
  name,
  sex,
  fatherName,
  birthDay,
  field,
  universityYear,
  university,
  nid,
  phone,
}) {
  return (
    <Box sx={{ marginTop: "30px" }} width="fit-content" margin={"auto"}>
      <LabelInformation label="نام و نام خانوادگی" value={name}>
        <AvatarIcon color="#9A9A9A" />
      </LabelInformation>
      <Box display="flex" justifyContent={"space-between"}>
        <LabelInformation
          label="جنسیت"
          value={sex === "MALE" ? "مرد " : "خانم"}
        >
          <AvatarIcon />
        </LabelInformation>
        <LabelInformation label="نام پدر" value={fatherName}>
          <AvatarIcon />
        </LabelInformation>
      </Box>
      <LabelInformation label="تاریخ تولد" value={birthDay}>
        <CalendarIcon />
      </LabelInformation>
      <LabelInformation
        label="تحصیلات دانشگاهی"
        value={`${universityYear} /${university} / ${field}`}
      >
        <UniversityCapIcon />
      </LabelInformation>
      <LabelInformation label="کد ملی" value={nid}>
        <DescriptionIcon />
      </LabelInformation>
      <LabelInformation label="شماره تلفن" value={phone}>
        <PhoneIcon2 />
      </LabelInformation>
    </Box>
  );
}
